/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getUserManagementList = (payload = { sort_by: 'asc' }, callback) =>
  req.list(
    c.GET_USER_MANAGEMENT,
    'api/v1/administrators/barangay_users',
    payload,
    callback
  );

export const showUserManagement = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_USER_MANAGEMENT,
    `api/v1/administrators/barangay_users/${id}`,
    payload,
    callback
  );

export const createUserManagement = (payload, callback) =>
  req.create(
    c.CREATE_USER_MANAGEMENT,
    'api/v1/administrators/barangay_users',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateUserManagement = (id, payload, callback) =>
  req.update(
    c.UPDATE_USER_MANAGEMENT,
    `api/v1/administrators/barangay_users/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateAdminPassword = (id, payload, callback) =>
  req.update(
    c.UPDATE_USER_MANAGEMENT,
    `api/v1/administrators/${id}/change_password`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `api/v1/administrators/barangay_users/${id}/activate`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const removeUserManagement = (id, payload, callback) =>
  req.remove(
    c.REMOVE_USER_MANAGEMENT,
    `api/v1/administrators/barangay_users/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const getRoleList = (
  payload = { is_paginated: 1, sort_by: 'asc' },
  callback
) =>
  req.list(c.GET_ROLE_LIST, 'api/v1/administrators/roles', payload, callback);
